import axios from "_l/api.request";
export function semanticSearch(data) {
  return axios.request({
    url: "/system/homePage/semanticSearch",
    method: "post",
    data: data
  });
}